import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 14px 14px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const IconBadge = styled.span`
  width: 38px;
  height: 38px;
  border-radius: ${(p) => p.theme.tokens.radii.md}px;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Titles = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.div`
  font-weight: 900;
  font-size: 19px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.3px;
`;

export const Sub = styled.div`
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const ClearButton = styled.button`
  border: none;
  background: none;
  color: #c0392b;
  font-weight: 800;
  font-size: 12.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  cursor: pointer;
  padding: 6px 4px;
  flex-shrink: 0;
`;
